<script lang="ts">
      import Button from '$lib/components/ui/Button.svelte'
      import { titleFromRelation, urlFromRelation } from '$lib/utils/payload/relations'

      type Example = {
            blockType: 'cta'
            id: '67d585d4243da26950361b71'
            link: 'https://aeon.co'
            size: 'normal'
            title: 'aeon.co'
            type: 'link'
            variant: 'primary'
      }

      type ExampleInternal = {
            fields: {
                  blockType: 'cta'
                  id: '67d59f9c74c479634bc224a5'
                  link: 'https://aeon.co'
                  page: any
                  size: 'normal'
                  title: 'aeon next'
                  type: 'internal'
                  variant: 'secondary'
            }
            type: 'inlineBlock'
            version: 1
      }

      let { node, format = '', children = undefined } = $props()

      const { size, variant } = $state(node)

      let url = $derived.by( () => {
        if( node.type == "link" ) return node.link as string
        else return urlFromRelation(node.relation)
      })
      
      let title = $derived.by( () => {
        if( node.type == "link" ) return node.title as string
        else if( node.type == "internal" && node.title_override ) return node.title_override as string
        else if( node.type == "internal" ) return titleFromRelation(node.relation)
        
        
      })
</script>

<span class="lexical-cta {format} inline-block my-2" style="vertical-align: baseline;">
      <Button class="lexical" {variant} {size} type="link" href={url} newTab={node.newTab}>
            {@html title}
      </Button>
</span>

<style lang=postcss>
      .lexical-cta :global( .lexical.buttom ) {
            @apply p-0;
      }

</style>